import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../config';
import Pagination from '../Pagination/Paginations';
import EntriesSelector from '../Pagination/EntriesSelector';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Select from 'react-select';



const CreateCandidate = () => {
  const [showForm, setShowForm] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [activeStatus, setActiveStatus] = useState('Applied');
  const roleId = localStorage.getItem('role_id');
  const [hods, setHods] = useState([]);
  const [interviewType, setInterviewType] = useState('Incharge');

  

  const STATUS_ORDER = ['Applied', 'Shortlisted', 'Interview', 'Recruitment', 'Hold', 'Rejected', 'Joined'];
const employeeOptions = employees.map(emp => ({
  value: emp.employee_id,
  label: `${emp.first_name} (${emp.employee_id})`
}));



  const [visibleStatuses, setVisibleStatuses] = useState([]);
 const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '31px',
    height: '31px',
    fontSize: '0.8rem', // smaller font for control
    paddingTop: '0px',
    paddingBottom: '0px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '31px',
    padding: '0 8px',
    fontSize: '0.8rem', // also reduce here
  }),
  input: (provided) => ({
    ...provided,
    fontSize: '0.8rem', // controls the input/placeholder
    margin: '0px',
    padding: '0px',
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '0.8rem',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '31px',
  }),
   menu: (provided) => ({
    ...provided,
    fontSize: '0.8rem',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '0.8rem',
  }),
};
console.log('recruit_by:', editData.recruit_by);
console.log('matched employee:', employees.find(e => e.employee_id == editData.recruit_by));





  const [candidate, setCandidate] = useState({
    job_id: '',
    first_name: '',
    last_name: '',
    dob: '',
    contact_no: '',
    gender: 'Select Gender',
    marriage_status: 'Single',
    email: '',
    address: '',
    resume_doc: null,
    refered_by: '',
    notes: '',
    qualification: '',
    experience: '',
    current_salary: '',
    expected_salary: '',
    created_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
  });

  useEffect(() => {
    const roleId = localStorage.getItem('role_id');
    const employeeId = localStorage.getItem('employee_id');

    if (!roleId || !employeeId) {
      console.error("Missing role_id or employee_id in localStorage");
      return;
    }


    axios.get(`${API_BASE_URL}/jobs`).then(res => setJobs(res.data));
     axios.get(`${API_BASE_URL}/employees`)
    .then(res => {
      setEmployees(res.data.employees); // For interview_by, incharge, etc.
      setHods(res.data.hods);           // For HOD dropdown
    });

   axios
  .get(`${API_BASE_URL}/job-permissions`, { params: { role_id: roleId } })
  .then(res => {
    console.log("Job permissions API response:", res.data);

    const rawStatuses = res.data
      .filter(p => String(p.role_id) === String(roleId))
      
      .map(p => p.field_name || p.job_status)  // ✅ handles both key names
      .filter(Boolean);
            console.log("roleId from localStorage:", roleId);
console.log("Permissions API response:", res.data);



    const unique = [...new Set(rawStatuses)];
    const STATUS_ORDER = ['Applied', 'Shortlisted', 'Interview', 'Recruitment', 'Hold', 'Rejected', 'Joined'];

    const sorted = STATUS_ORDER.filter(status =>
      unique.map(u => u.toLowerCase()).includes(status.toLowerCase()) // ✅ ignore case
    );

    console.log("Visible statuses:", sorted);
    setVisibleStatuses(sorted);

    if (sorted.length > 0) setActiveStatus(sorted[0]);
  })
  .catch(err => console.error("Error fetching job permissions:", err));


    // ✅ Fetch candidates
    axios.get(`${API_BASE_URL}/candidates`, {
      params: { role_id: roleId, employee_id: employeeId }
    })
      .then(res => setCandidates(res.data))
      .catch(err => console.error('Error fetching candidates:', err));
  }, []);




  const fetchCandidates = () => {
    const roleId = localStorage.getItem('role_id');
    const employeeId = localStorage.getItem('employee_id');

    axios
      .get(`${API_BASE_URL}/candidates`, {
        params: { role_id: roleId, employee_id: employeeId  }
      })
      .then((res) => setCandidates(res.data))
      .catch((err) => console.error('Error fetching candidates:', err));
  };





  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'resume_doc') {
      setCandidate(prev => ({ ...prev, resume_doc: files[0] }));
    } else {
      setCandidate(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleEditClick = (candidate) => {
    setSelectedCandidate(candidate);
    setEditData({ ...candidate, job_status: candidate.job_status || 'Applied' });
    setShowEditModal(true);
  };


  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData(prev => ({ ...prev, [name]: value }));
  };
const handleEditSubmit = async () => {
  try {
    const errors = [];

    if (!editData.first_name) errors.push("First Name is required.");
    if (!editData.email) errors.push("Email is required.");
    if (!editData.contact_no) errors.push("Contact No is required.");
    if (!editData.job_status) errors.push("Job Status is required.");

    if (editData.job_status === "Interview") {
      if (!editData.interview_date) errors.push("Interview Date is required.");
      if (!editData.interview_time) errors.push("Interview Time is required.");
      if (!editData.interview_by) errors.push("Interview By is required.");
      if (!editData.first_level_reporting)
        errors.push("First Level Reporting is required.");
    }

    if (
      editData.job_status === "Recruitment" &&
      activeStatus !== "Hold" &&
      activeStatus !== "Interview" &&
      !editData.recruit_by
    ) {
      errors.push("Recruit By is required.");
    }

    if (editData.job_status === "Hold" && !editData.hold_by)
      errors.push("Hold By is required.");

    if (editData.job_status === "Joined") {
      if (!editData.incharge_id) errors.push("Incharge is required.");
      if (!editData.hod_id) errors.push("HOD is required.");
      if (!editData.employee_role) errors.push("Employee Role is required.");
      if (!editData.probation_days)
        errors.push("Probation Days are required.");
    }

    // ❌ Validation errors → STOP & SHOW
    if (errors.length > 0) {
      errors.forEach((err, i) => setTimeout(() => toast.error(err), i * 300));
      return;
    }

    // Payload
    const payload = {
      ...editData,
      employee_id: localStorage.getItem("employee_id"),
    };

    // ---- API CALL ----
    const response = await axios.post(
      `${API_BASE_URL}/update-candidate/${selectedCandidate.application_id}`,
      payload
    );

    // ---- SUCCESS ----
    toast.success(response.data.message || "Candidate updated successfully!");

    // Joined → redirect
    if (response.data.redirect_url) {
      setTimeout(() => {
        window.location.href = response.data.redirect_url;
      }, 1500);
      return;
    }

    // Close modal
    setShowEditModal(false);
    setCurrentPage(1);

    // Refresh list
    const roleId = localStorage.getItem("role_id");
    const employeeId = localStorage.getItem("employee_id");

    const res = await axios.get(`${API_BASE_URL}/candidates`, {
      params: { role_id: roleId, employee_id: employeeId },
    });

    setCandidates(res.data);
    setActiveStatus(editData.job_status);

  } catch (error) {
    console.log("ERROR =>", error);

    // 🟢 Show ONLY safe message
    toast.error(error.response?.data?.error || "Something went wrong");
  }
};






const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData();
  Object.keys(candidate).forEach(key => {
    formData.append(key, candidate[key]);
  });

  try {
    const res = await axios.post(`${API_BASE_URL}/create-candidate`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    toast.success(res.data.message);
    fetchCandidates();
    setShowForm(false);

  } catch (error) {
console.log("ERROR RESPONSE:", error.response);

    if (error.response?.status === 422) {
      toast.error(error.response.data.error);
      return;
    }

    toast.error("Something went wrong");
  }
};


  const filteredCandidates = candidates.filter(c => {
    const matchesStatus = c.job_status === activeStatus;
    const matchesSearch =
      c.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.last_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.job_title?.toLowerCase().includes(searchTerm.toLowerCase());
      

    return matchesStatus && matchesSearch;
  }) .sort((a, b) => new Date(b.status_changed_on || b.modified_at || b.created_at) - new Date(a.status_changed_on || a.modified_at || a.created_at))

  
  const totalPages = Math.ceil(filteredCandidates.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentCandidates = filteredCandidates.slice(indexOfFirst, indexOfLast);

  return (
    <div className="container mt-2">
     <ToastContainer position="bottom-right" autoClose={3000} />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <ul className="nav nav-tabs mb-3">
          {visibleStatuses.map(status => (
            <li className="nav-item" key={status}>
              <a
                href="#!"
                className={`nav-link ${activeStatus === status ? 'active' : ''}`}
                onClick={e => {
                  e.preventDefault();
                  setActiveStatus(status);
                }}
                style={{ cursor: 'pointer' }}
              >
                {status}
              </a>
            </li>
          ))}
        </ul>




        {!['2', '3','6'].includes(localStorage.getItem('role_id')) && (
          <button className="btn btn-success" onClick={() => setShowForm(!showForm)}>
            {showForm ? 'Hide Form' : 'Add Candidate'}
          </button>
        )}

      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="border p-4 mb-4 bg-light rounded">
          <div className="row">
           <div className="col-md-6 mb-3">
  <label>Job <span style={{ color: 'red' }}>*</span></label>
 <Select
  name="job_id"
  value={jobs.find(j => j.job_id === candidate.job_id) || null}
  onChange={(selectedOption) =>
    setCandidate(prev => ({
      ...prev,
      job_id: selectedOption ? selectedOption.job_id : ''
    }))
  }
  options={jobs}
  getOptionLabel={option => option.job_title}
  getOptionValue={option => option.job_id}
  placeholder="Select Job"
  isClearable
  className="form-control-sm"
  classNamePrefix="react-select"
  styles={customStyles}
/>

</div>
            <div className="col-md-6 mb-3">
              <label>First Name <span style={{ color: 'red' }}>*</span></label>
              <input type="text" name="first_name" value={candidate.first_name} onChange={handleChange} className="form-control"  />
            </div>
            <div className="col-md-6 mb-3">
              <label>Last Name <span style={{ color: 'red' }}>*</span></label>
              <input type="text" name="last_name" value={candidate.last_name} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
              <label>Date of Birth <span style={{ color: 'red' }}>*</span></label>
              <input type="date" name="dob" value={candidate.dob} onChange={handleChange} className="form-control"  />
            </div>
            <div className="col-md-6 mb-3">
              <label>Contact No <span style={{ color: 'red' }}>*</span></label>
              <input type="text" name="contact_no" value={candidate.contact_no} onChange={handleChange} className="form-control"  />
            </div>
            <div className="col-md-6 mb-3">
              <label>Gender <span style={{ color: 'red' }}>*</span></label>
              <select name="gender" value={candidate.gender} onChange={handleChange} className="form-control">
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label>Marriage Status <span style={{ color: 'red' }}>*</span></label>
              <select name="marriage_status" value={candidate.marriage_status} onChange={handleChange} className="form-control">
                <option value="Single">Single</option>
                <option value="Married">Married</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label>Email <span style={{ color: 'red' }}>*</span></label>
              <input type="email" name="email" value={candidate.email} onChange={handleChange} className="form-control"  />
            </div>
            <div className="col-md-12 mb-3">
              <label>Address <span style={{ color: 'red' }}>*</span></label>
              <textarea name="address" value={candidate.address} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-12 mb-3">
              <label>Resume Document (PDF, DOC, DOCX) <span style={{ color: 'red' }}>*</span></label>
              <input
                type="file"
                name="resume_doc"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                className="form-control"
              />
            </div>
           <div className="col-md-6 mb-3">
  <label>Referred By <span style={{ color: 'red' }}>*</span></label>

  <Select
  name="refered_by"
  value={
    candidate.refered_by
      ? employees.find(emp => emp.employee_id === candidate.refered_by)
      : { employee_id: 0, first_name: "No Refer" }
  }
  onChange={(selectedOption) =>
    setCandidate(prev => ({
      ...prev,
      refered_by: selectedOption ? selectedOption.employee_id : 0
    }))
  }
  options={[
    { employee_id: 0, first_name: "No Refer" },  // <---- use 0
    ...employees
  ]}
  getOptionLabel={(option) =>
    option.employee_id === 0 
      ? "No Refer"
      : `${option.first_name} (${option.employee_id})`
  }
  getOptionValue={(option) => option.employee_id}
  placeholder="Select Employee"
  isClearable
  className="form-control-sm"
  classNamePrefix="react-select"
  styles={customStyles}
/>

</div>


            <div className="col-md-6 mb-3">
              <label>Notes <span style={{ color: 'red' }}>*</span></label>
              <input type="text" name="notes" value={candidate.notes} onChange={handleChange} className="form-control"  required/>
            </div>
            <div className="col-md-6 mb-3">
              <label>Qualification <span style={{ color: 'red' }}>*</span></label>
              <input type="text" name="qualification" value={candidate.qualification} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
              <label>Experience <span style={{ color: 'red' }}>*</span></label>
              <input type="text" name="experience" value={candidate.experience} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
              <label>Current Salary<span style={{ color: 'red' }}>*</span></label>
              <input type="text" name="current_salary" value={candidate.current_salary} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
              <label>Expected Salary <span style={{ color: 'red' }}>*</span></label>
              <input type="text" name="expected_salary" value={candidate.expected_salary} onChange={handleChange} className="form-control" />
            </div>
          </div>
          <div className="text-end">
            <button type="submit" className="btn btn-primary">Submit</button>
          </div>
        </form>
      )}

    {/* Top Row: Header + Entries + Search */}
<div className="d-flex justify-content-between align-items-center bg-white px-2 pt-2">
  <div
  className="text fw-bold"
  style={{ color: '#dc3545', fontSize: '1.25rem' }}
>
  Candidate List
</div>

  <div className="d-flex align-items-center gap-2">
    <EntriesSelector
      entriesPerPage={entriesPerPage}
      setEntriesPerPage={setEntriesPerPage}
      setCurrentPage={setCurrentPage}
    />
    <input
      type="text"
      placeholder="Search"
      value={searchTerm}
      onChange={e => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      className="form-control form-control-sm"
      style={{ width: '200px' }}
    />
  </div>
</div>

{/* Table with no extra margin or padding */}
<div className="table-responsive bg-white px-2 pb-2">
  <table className="table align-middle mb-0 table-striped">
    <thead>
      <tr>
        <th className="text-uppercase text-secondary small">Action</th>
        <th className="text-uppercase text-secondary small">Job</th>
        <th className="text-uppercase text-secondary small">Name</th>
        <th className="text-uppercase text-secondary small">Referred By</th>
        <th className="text-uppercase text-secondary small">Email</th>
        <th className="text-uppercase text-secondary small">Status</th>
        <th className="text-uppercase text-secondary small">Experience</th>
        <th className="text-uppercase text-secondary small">Apply Date</th>
        {activeStatus === 'Interview' && (
          <>
            <th className="text-uppercase text-secondary small">Interview Date</th>
            <th className="text-uppercase text-secondary small">Time</th>
          </>
        )}
      </tr>
    </thead>
    <tbody>
      {currentCandidates.length > 0 ? (
        currentCandidates.map((c, index) => (
          <tr key={index}>
            <td>
              {(c.job_status !== 'Joined' && c.job_status !== 'Rejected') && (
                <button
                  className="btn btn-link p-0"
                  onClick={() => handleEditClick(c)}
                  title="Edit"
                >
                  <i className="bi bi-pencil-square fs-5 text-dark"></i>
                </button>
              )}
            </td>
            <td>{c.job_title}</td>
            <td>{c.first_name} {c.last_name}</td>
<td>{c.refered_by_name || "No Refer"}</td>
            <td>{c.email}</td>
            <td>
              <span className={`badge rounded-pill text-white px-3 py-1 small fw-normal ${
                c.job_status === 'Applied' ? 'bg-danger' :
                c.job_status === 'Shortlisted' ? 'bg-success' :
                c.job_status === 'Hold' ? 'bg-warning text-dark' :
                c.job_status === 'Rejected' ? 'bg-dark' :
                c.job_status === 'Recruitment' ? 'bg-info' :
                c.job_status === 'Interview' ? 'bg-secondary' :
                c.job_status === 'Joined' ? 'bg-primary' :
                'bg-light text-dark'
              }`}>
                {c.job_status}
              </span>
            </td>
            <td>{c.experience}</td>
            <td>{c.created_at}</td>
            {activeStatus === 'Interview' && (
              <>
                <td>{c.interview_date || '—'}</td>
                <td>{c.interview_time || '—'}</td>
              </>
            )}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="9" className="text-center">No candidates found</td>
        </tr>
      )}
    </tbody>
  </table>
</div>


      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
      {showEditModal && selectedCandidate && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editData.first_name}</h5>
                <button type="button" className="btn btn-sm btn-danger" onClick={() => setShowEditModal(false)}>
                  &times;
                </button>
              </div>
              <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="row">
                      {[
  ['First Name', 'first_name'],
  ['Last Name', 'last_name'],
  ['Email', 'email'],
  ['Contact No', 'contact_no'],
  ['Experience', 'experience'],
  ['Notes *', 'notes'],
].map(([label, name]) => (
  <div key={name} className="col-md-6 mb-2">
    <label className="form-label mb-1">{label}</label>
    {name === 'notes' ? (
      <textarea
        name="notes"
        value={editData.notes || ''}
        onChange={handleEditChange}
        className="form-control form-control-sm"
        rows={2}
      required/>
    ) : (
      <input
        type="text"
        name={name}
        value={editData[name] || ''}
        onChange={handleEditChange}
        className="form-control form-control-sm"
      />
    )}
  </div>
))}

                      <div className="col-md-6 mb-2">
                        <label className="form-label mb-1">Job Status</label>
                        <select name="job_status" value={editData.job_status || ''} onChange={handleEditChange} className="form-control form-control-sm">
                          <option value="">Select Status</option>

                          {activeStatus === 'Applied' && (
                            <>
                              <option value="Shortlisted">Shortlisted</option>
                              
                              <option value="Rejected">Rejected</option>
                            </>
                          )}

                          {activeStatus === 'Shortlisted' && (
                            <>
                              <option value="Interview">Interview</option>
                              <option value="Hold">Hold</option>
                              <option value="Rejected">Rejected</option>
                            </>
                          )}

                          {activeStatus === 'Interview' && (
  <>
    <option value="Recruitment">Recruitment</option>
    {roleId === '1' && (
      <>
        <option value="Hold">Hold</option>
        <option value="Rejected">Rejected</option>
      </>
    )}
  </>
)}


                          {activeStatus === 'Recruitment' && (
                            <>
                              <option value="Joined">Joined</option>
                              <option value="Hold">Hold</option>
                              <option value="Rejected">Rejected</option>
                            </>
                          )}

                          {activeStatus === 'Hold' && (
                            <>
                              <option value="Rejected">Rejected</option>
                                <option value="Recruitment">Recruitment</option>
                            </>
                          )}
                        </select>

                      </div>

                      {editData.job_status === 'Interview' && (
                        <>
                          <div className="col-md-6 mb-2">
                            <label className="form-label mb-1">Interview Date<span style={{color:'red'}}>*</span></label>
                            <input
                              type="date"
                              name="interview_date"
                              value={editData.interview_date || ''}
                              onChange={handleEditChange}
                              className="form-control form-control-sm"
                            />
                          </div>
                          <div className="col-md-6 mb-2">
                            <label className="form-label mb-1">Interview Time<span style={{color:'red'}}>*</span></label>
                            <input
                              type="time"
                              name="interview_time"
                              value={editData.interview_time || ''}
                              onChange={handleEditChange}
                              className="form-control form-control-sm"
                            />
                          </div>
                         

<div className="col-md-6 mb-2">
  <label className="form-label mb-1">Select Type</label>
  <select
    className="form-control form-control-sm"
    value={interviewType}
    onChange={(e) => setInterviewType(e.target.value)}
  >
    <option value="Incharge">Incharge</option>
    <option value="HOD">HOD</option>
  </select>
</div>

<div className="col-md-6 mb-2">
  <label className="form-label mb-1">Interview By<span style={{color:'red'}}>*</span></label>
  <Select
  name="interview_by"
  styles={customStyles}
  classNamePrefix="react-select"
  value={
    employees.concat(hods).find(
      emp => String(emp.employee_id) === String(editData.interview_by)
    ) || null
  }
  
  onChange={selected => {
    handleEditChange({
      target: { name: 'interview_by', value: selected ? selected.employee_id : '' }
    });
  }}
  
  options={
    interviewType === 'Incharge'
      ? employees.filter(emp => [2, 6].includes(emp.user_role_id))
      : hods  // 👈 FIXED — now uses HOD list correctly
  }

  getOptionLabel={emp => `${emp.first_name} (${emp.employee_id})`}
  getOptionValue={emp => emp.employee_id}
  placeholder={`Select ${interviewType}`}
  isClearable
/>

</div>


<div className="col-md-6 mb-2">
  <label className="form-label mb-1">First Level Reporting<span style={{color:'red'}}>*</span></label>
  <Select
    name="first_level_reporting"
    styles={customStyles}
    classNamePrefix="react-select"
   value={employees.find(emp => String(emp.employee_id) === String(editData.first_level_reporting)) || null}
    onChange={selected => {
      handleEditChange({
        target: { name: 'first_level_reporting', value: selected ? selected.employee_id : '' }
      });
    }}
    options={employees}
    getOptionLabel={emp => `${emp.first_name} (${emp.employee_id})`}
    getOptionValue={emp => emp.employee_id}
    placeholder="Select Employee"
    isClearable
  />
</div>

                        </>
                      )}
                     



                      {editData.job_status === 'Hold' && (
                        <>
                          <div className="col-md-6 mb-2">
                            <label className="form-label mb-1">Hold By</label>
                            <select
                              name="hold_by"
                              value={editData.hold_by || ''}
                              onChange={handleEditChange}
                              className="form-control form-control-sm"
                            >
                              <option value="">Select Employee</option>
                              {employees.map(emp => (
                                <option key={emp.employee_id} value={emp.employee_id}>
                                  {emp.first_name} ({emp.employee_id})
                                </option>
                              ))}
                            </select>
                          </div>


                        </>
                      )}

                    {editData.job_status === 'Recruitment' && activeStatus !== 'Hold' && (
 <div className="col-md-6 mb-2">
  <label className="form-label mb-1">Recruit By</label>

  {editData.recruit_by ? (
    // 🔒 Show read-only once set
    <input
      type="text"
      className="form-control form-control-sm"
      value={
        employees.find(e => e.employee_id == editData.recruit_by)?.first_name +
        ` (${editData.recruit_by})` || '—'
      }
      readOnly
    />
  ) : (
    // 🧠 Automatically set recruit_by = interview_by
    <input
      type="text"
      className="form-control form-control-sm"
      value={
        employees.find(e => e.employee_id == editData.interview_by)?.first_name +
        ` (${editData.interview_by})` || '—'
      }
      readOnly
    />
  )}
</div>

)}

                      {editData.job_status === 'Joined' && (
                        <>
                         <div className="col-md-6 mb-2">
  <label className="form-label mb-1">Incharge</label>
  <Select
    name="incharge_id"
    styles={customStyles}
    classNamePrefix="react-select"
    value={employees.find(emp => String(emp.employee_id) === String(editData.incharge_id)) || null}
    onChange={selected =>
      handleEditChange({
        target: { name: 'incharge_id', value: selected ? selected.employee_id : '' }
      })
    }
    options={employees}
    getOptionLabel={emp => `${emp.first_name} (${emp.employee_id})`}
    getOptionValue={emp => emp.employee_id}
    placeholder="Select Incharge"
    isClearable
  />
</div>


                          <div className="col-md-6 mb-2">
                            <label className="form-label mb-1">HOD</label>
                            <select
  name="hod_id"
  value={editData.hod_id || ''}
  onChange={handleEditChange}
  className="form-control form-control-sm"
>
  <option value="">Select HOD</option>
  {hods.map(emp => (
    <option key={emp.employee_id} value={emp.employee_id}>
      {emp.first_name} ({emp.employee_id})
    </option>
  ))}
</select>

                          </div>
<div className="col-md-6 mb-2">
  <label className="form-label mb-1">Employee Role</label>
  <select
    name="employee_role"
    value={editData.employee_role || ''}
    onChange={(e) => {
      const role = e.target.value;
      setEditData(prev => ({
        ...prev,
        employee_role: role
      }));
    }}
    className="form-control form-control-sm"
  >
    <option value="">Select Role</option>
    <option value="1">Regular Employee</option>
            <option value="2">Doctor</option>
            <option value="3">House keeping</option>
            <option value="4">Security</option>
            <option value="5">Canteen</option>
            <option value="6">Intern Students</option>
  </select>
</div>


                          <div className="col-md-6 mb-2">
                            <label className="form-label mb-1">Probation Days</label>
                            <input
                              type="number"
                              name="probation_days"
                              value={editData.probation_days || ''}
                              onChange={handleEditChange}
                              className="form-control form-control-sm"
                            />
                          </div>
                          <div className="col-md-6 mb-2">
      <label className="form-label mb-1">Date of Joining</label>
      <input
        type="date"
        name="joined_on"
        value={editData.joined_on || ''}
        onChange={handleEditChange}
        className="form-control form-control-sm"
      />
    </div>
  </>
)}
                       

                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card shadow-sm">
                      <div className="card-header bg-primary text-white fw-bold py-2 px-3">
                        Candidate Details
                      </div>
                      <div className="card-body p-0">
                        <table className="table table-sm table-striped mb-0">
                          <tbody>
                           {[
  ['First Name', editData.first_name],
  ['Last Name', editData.last_name],
  ['Email', editData.email],
  ['Mobile', editData.contact_no],
  ['Notes', editData.notes],

  ...(editData.job_status === 'Interview'
    ? [
        ['Interview Date', editData.interview_date],
        ['Interview Time', editData.interview_time],
        
        [
          'Interview By',
          employees.find(e => e.employee_id == editData.interview_by)?.first_name +
            ` (${editData.interview_by})`
        ],
        ['Notes', editData.notes || 'j'], 
      ]
    : []),

...(activeStatus === 'Recruitment'
  ? [
      [
        'Recruit By',
        (() => {
          const emp = employees.find(e => e.employee_id == editData.recruit_by);
          return emp ? `${emp.first_name} (${emp.employee_id})` : '—';
        })()
      ],
    ]
  : []),

].map(([label, value]) => (
  <tr key={label}>
    <td className="bg-light fw-semibold" style={{ width: '40%' }}>{label}</td>
    <td>{value || <span className="text-muted">—</span>}</td>
  </tr>
))}


                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Close</button>
                <button className="btn btn-primary" onClick={handleEditSubmit}>Save Changes</button>
              </div>
            </div>
          </div>
        </div>
      )}



    </div>
  );
};

export default CreateCandidate;